(function () {
  'use strict';

  angular
    .module('factories.nativeBridge', [])
    .factory('NativeBridge', NativeBridge);

  NativeBridge.$inject = ['$window'];

  function NativeBridge($window) {
    if ($window.nativeBridge)
      return $window.nativeBridge;

    // special case object for the browser
    if (!$window.nativeBridge) {
      $window.nativeBridge = {
        fireHandler: function (key, value, cb) {
          if (cb) cb();
        },
        registerHandler: function (key, cb) {
        },
        send: function (value, cb) {
          if (cb) cb();
        }
      };
      return $window.nativeBridge;
    }
  }

})();
